import { Barber } from '@water-web/types';
import { QueryKey } from 'react-query';

import { EndpointQuery } from '../../request';
import { hashKey } from '../../utils/haskey';
import { queryKeys } from './queryKeys';

export interface PublicFeatureFlagPayload {
  shopId: string;
  flags: string[];
}

export class PublicFeatureFlagsQuery extends EndpointQuery<Barber, PublicFeatureFlagPayload> {
  constructor(apiUrl: string) {
    super();

    this.baseUrl = apiUrl;
    this.meta = {
      cacheTime: 60 * 60 * 1000,
    };
  }

  getKey(payload: PublicFeatureFlagPayload): QueryKey {
    const params = { names: payload.flags };
    return queryKeys.byShop(payload).concat(hashKey(params));
  }

  request(payload: PublicFeatureFlagPayload): Promise<any> {
    return this.http.get(`/v1/shop/${payload.shopId}/flags`, {
      headers: this.buildHeaders(),
      search: { names: payload.flags },
      resourceUrl: '/shop/:shopId/flags',
    });
  }
}
